import MuiMoreVert from '@mui/icons-material/MoreVert';
import { SvgIconProps } from '@mui/material/SvgIcon';

export type MoreVertProps = SvgIconProps;

export const MoreVert = (props: MoreVertProps) => {
  return <MuiMoreVert {...props} />;
};
